import ListeTypeTaxePage from "@/pages/GesCom/TypeTaxe/ListeTypeTaxePage.vue";

interface MenuItem {
    headTitle1?: string;
    headTitle2?: string;
    title?: string;
    icon?: string;
    icon1?: string;
    type: string;
    badgeType?: string;
    badgeValue?: string;
    active?: boolean;
    isPinned?: boolean;
    path?: string;
    children?: MenuItem[];
    bookmark?: boolean;
    role?: string;
}

export const menu: MenuItem[] = [
    {
        path: "/accueil/tableau-bord",
        title: "Tableau de bord",
        type: "link",
        icon: "stroke-home",
        icon1: "fill-home",
        active: false,
        isPinned: false,
        role: "DashBord"
    },


    {
        headTitle1: "Gestion des inventaires",
        headTitle2: "Gestion des inventaires",
        type: "headtitle",
        //role: "ListProduit"
        role: "ListProduit|ListFamille|ListConditionnement|ListMagasin|AddMouvement|EtatInventaire|ListMouvement"
    },
    {
        title: "Gestion des produits",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit",
        children: [
            {
                path: "/produits/liste-produits",
                title: " produits",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListProduit"
            },
            {
                path: "/familles/liste-familles",
                title: "familles",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListFamille"
            },
            {
                path: "/conditionnements/liste-conditionnements",
                title: "conditionnements",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListConditionnement"
            },
        ]
    },

    {
        title: "Gestion des inventaires",
        icon: "stroke-learning",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit|ListFamille|ListConditionnement|ListMotifSuivi|ListMagasin|ListPointVente|ListMarque",

        children: [
            {
                path: "/inventaires/liste-inventaires",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des inventaires",
                isPinned: false,
                type: "link",
                role: "ListInventaire"
            },

            {
                path: "/inventaires/liste-fiche-inventaires",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Liste des fiches d'inventaires",
                isPinned: false,
                type: "link",
                role: "ListeFicheProduit"
            },

            {
                path: "/inventaires/ajouter-inventaire",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Créer une fiche d'inventaire",
                isPinned: false,
                type: "link",
                role: "ListProduit"
            },
            {
                path: "/inventaires/inventorier",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Inventorier",
                isPinned: false,
                type: "link",
                role: "EditInventaire"
            },
            {
                path: "/inventaires/liste-produit-inventaire",
                icon: "stroke-email",
                icon1: "fill-email",
                title: "Etats inventaire",
                isPinned: false,
                type: "link",
                role: "ListMouvement"
            },
        ]
    },

    {
        title: "Gestion des Clients",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeClient|AddCompte|AddClient|ListeMesClients",
        children: [
            {
                path: "/clients/liste-clients",
                title: "Clients",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeClient"
            }
        ]
    },

    /*{
        title: "Gestion des comptes",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeCompte|AddCompte",
        children: [
            {
                path: "/comptes/ajouter-compte",
                title: "Ajouter un compte",
                type: "link",
                role: "AddCompte"
            },
            {
                path: "/comptes/liste-comptes",
                title: "Liste des comptes",
                type: "link",
                role: "ListCompte"
            },

        ]
    },
    {
        title: "Gestion des contrats",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeContrat|AddContrat",
        children: [
            {
                path: "/contrats/ajouter-contrat",
                title: "Ajouter un contrat",
                type: "link",
                role: "AddContrat"
            },
            {
                path: "/contrats/liste-contrats",
                title: "Liste des contrats",
                type: "link",
                role: "ListContrat"
            },

        ]
    },*/

    // {
    //     title: "Gestion des échéances",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //     role: "AddEcheance|ListEcheance",
    //     //role: "ListMagasin",
    //     children: [
    //         // {
    //         //     path: "/echeance/ajouter-echeance",
    //         //     title: "Ajouter une échéance",
    //         //     type: "link",
    //         //     role: "AddEcheance"
    //         //     // role: "ListMagasin"
    //         // },
            
    //         {
    //             path: "/echeances/liste-echeances",
    //             title: "Liste des échéances",
    //             type: "link",
    //             role: "ListEcheance"
    //            //role: "ListEcheance"
    //         },
    //     ]
    // },

    // {
    //     title: "Gestion des règlements",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
       
    //     role: "ListReglement|AddReglement",
    //     children: [
    //         {
    //             path: "/reglements/ajouter-reglement",
    //             title: "Ajouter un règlement",
    //             type: "link",
                
    //             role: "AddReglement"
    //         },
    //         {
    //             path: "/reglements/liste-reglements",
    //             title: "Liste des règlements",
    //             type: "link",
                
    //             role: "ListReglement"
    //         },
    //     ]
    // },

    {
        title: "Fournisseurs",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListFournisseur|AddFournisseur",
        children: [
            {
                path: "/fournisseurs/ajouter-fournisseur",
                title: "Ajouter un fournisseur",
                role: "AddFournisseur",
                type: "link"
            },
            {
                path: "/fournisseurs/liste-fournisseurs",
                title: "Liste des fournisseurs",
                role: "ListFournisseur",
                type: "link"
            },
        ]
    },

    
    {
        title: "Vente",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/ventes/ajouter-vente",
                title: "Ajouter une vente",
                type: "link"
            },
            {
                path: "/ventes/liste-ventes",
                title: "Liste des ventes",
                type: "link"
            },
        ]
    },

    {
        title: "Etats",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
             {
                path: "/etats/produits-disponibles",
                title: "stock actuelle",
                type: "link"
            },
            {
                path: "/etats/produits-vendus",
                title: "Liste des produits vendus",
                type: "link"
            },
            {
                path: "/etats/produits-rupture",
                title: "Liste des produits en rupture de stock",
                type: "link"
            },
            {
                path: "/etats/etat-produits-entree",
                title: "Liste des produits entrées",
                type: "link"
            },
            {
                path: "/etats/etats-produits-sorties",
                title: "Liste des produits sorties",
                type: "link"
            },
            {
                path: "/etats/ca-client",
                title: `Chiffre d'affaire par client`,
                type: "link"
            },
            // {
            //     path: "/etats/commandes-par-utilisateur",
            //     title: `Nombre des commandes par utilisateur`,
            //     type: "link"
            // }
        ]
    },

    {
        title: "Stock",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/sorties/liste-sorties",
                title: "Liste des sorties",
                type: "link"
            },
            {
                path: "/approvisionnements/liste-approvisionnements",
                title: "Liste des approvisionnements",
                type: "link"
            }
        ]
    },

    {
        title: "Caisse",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/caisses/liste-caisses",
                title: "Liste des caisses",
                type: "link"
            },

            // {
            //     path: "/depenses/liste-depenses",
            //     title: "Liste des dépenses",
            //     type: "link"
            // },
            // {
            //     path: "/depots/liste-depots",
            //     title: "Liste des dépôts",
            //     type: "link"
            // },
            
            {
                path: "/OuverturesFermetures",
                title: "Liste des caisses ouvertes et fermées",
                type: "link"
            },
            
        ]
    },

    {
         title: "Société",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        children: [
             {
                path: "/ma-societe/liste",
                title: "société",
                type: "link"
            },
           
        ]
    },

    // {
    //     title: "Gestion des dépots",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //     role: "ListDepot|AddDepot",
    //     children: [
    //         {
    //             path: "/depots/ajouter-depot",
    //             title: "Ajouter un dépôt",
    //             role: "AddDepot",
    //             type: "link"

    //         },
    //         {
    //             path: "/depots/liste-depots",
    //             title: "Liste des dépôts",
    //             role: "ListDepot",
    //             type: "link"

    //         },

    //     ]
    // },

    // {
    //     title: "Gestion des transactions",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //    role: "ListTransaction|AddTransaction",
    //     children: [
    //         // {
    //         //     path: "/transactions/ajouter-transaction",
    //         //     title: "Ajouter une transaction",
    //         //     //role: "AddTransaction",
    //         //     role:"ListMagasin",
    //         //     type: "link"
    //         // },
    //         {
    //             path: "/transactions/liste-transactions",
    //             title: "Liste des transactions",
    //             role: "ListTransaction",
    //             type: "link"

    //         },

    //     ]
    // },
     
 /* 
     {
        title: "Mes clients",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListeClientAffecters",
        children: [
            {
                path: "/clientAffecter/liste-clientAffecter",
                title: "Liste des clients affectés",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListeClientAffecters"
            },
        ]
    },*/

    //  {
    //     title: "Gestion des rapports",
    //     icon: "stroke-user",
    //     icon1: "fill-user",
    //     type: "sub",
    //     badgeType: "light-primary",
    //     active: false,
    //     isPinned: false,
    //     //role: "ListeClient",
    //     role: "AddRapportRelance|ListRapportRelance",
    //     children: [
    //         {
    //             path: "/rapportRelances/ajouter-rapportRelance",
    //             title: "Ajouter un rapport",
    //             type: "link",
    //             icon: "stroke-learning",
    //             icon1: "fill-learning",
    //             isPinned: false,
    //             role: "AddRapportRelance"
    //         },
    //         {
    //             path: "/rapportRelances/liste-rapportRelance",
    //             title: "Liste des rapports",
    //             type: "link",
    //             icon: "stroke-learning",
    //             icon1: "fill-learning",
    //             isPinned: false,
    //             role: "ListRapportRelance"
    //         },
    //     ]
    // },

    {
        title: "Paramètres",
        icon: "stroke-learning",
        icon1: "fill-learning",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListProduit|ListFamille|ListConditionnement|ListMotifSuivi|ListMagasin|ListPointVente|AddClient|ListClient|ListMarque|ListeCodification|ListDomaineActivite|ListTaxe|ListTypeTaxe|ListModeRegelement|ListPiece|ListBanque|ListCompteEntreprise|ListeClientAffecters",
        children: [

            // {
            //     path: "/motifSuivis/liste-motifSuivi",
            //     icon: "stroke-email",
            //     icon1: "fill-email",
            //     title: "MotifSuivi",
            //     isPinned: false,
            //     type: "link",
            //     role: "ListMotifSuivi"

            // },
            // {
            //     path: "/codifications/liste-codifications",
            //     title: "codifications",
            //     type: "link",
            //     icon: "stroke-learning",
            //     icon1: "fill-learning",
            //     isPinned: false,
            //     role: "ListeCodification"
            // },
            {
                path: "/magasins/liste-magasins",
                title: "magasins",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                type: "link",
                role: "ListMagasin"
            },
            {
                path: "/point-ventes/liste-point-ventes",
                title: "points de vente",
                type: "link",
                icon: "stroke-learning",
                icon1: "fill-learning",
                isPinned: false,
                role: "ListPointVente"
            },
            // {
            //     path: "/banques/liste-banques",
            //     title: "banques",
            //     type: "link",
            //     icon: "stroke-learning",
            //     icon1: "fill-learning",
            //     isPinned: false,
            //     role: "ListBanque"
            // },
        ]
    },


    {
        headTitle1: "Gestion des utilisateurs",
        headTitle2: "Utilisateurs, Rôles et permissions",
        type: "headtitle",
        role: "AddUser|ListUser|AddRole|ListRole|ListPermission"
    },

    {
        title: "Gestion des utilisateurs",
        icon: "stroke-user",
        icon1: "fill-user",
        type: "sub",
        badgeType: "light-primary",
        active: false,
        isPinned: false,
        role: "ListUser",
        children: [

            {
                title: "Utilisateurs",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListUser",
                children: [
                    {
                        path: "/utilisateurs/ajouter-utilisateur",
                        title: "Ajouter un utilisateur",
                        type: "link",
                        role: "AddUser"
                    },
                    {
                        path: "/utilisateurs/liste-utilisateur",
                        title: "Liste des utilisateurs",
                        type: "link",
                        role: "ListUser"
                    },
                ]
            },
            {
                title: "Role",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListRole",
                children: [
                    {
                        path: "/roles/ajouter-role",
                        title: "Ajouter un rôle",
                        type: "link",
                        role: "AddRole"
                    },
                    {
                        path: "/roles/liste-role",
                        title: "Liste des rôles",
                        type: "link",
                        role: "ListRole"
                    },
                ]
            },
            {
                title: "Permissions",
                icon: "stroke-user",
                icon1: "fill-user",
                type: "sub",
                badgeType: "light-primary",
                active: false,
                isPinned: false,
                role: "ListPermission",
                children: [
                    {
                        path: "/permissions/liste-permission",
                        title: "Liste des permissions",
                        type: "link",
                        role: "ListPermission"
                    },

                ]
            },


        ]
    },
]


